import type { User as FirebaseUser } from "firebase/auth";
import type { User } from "./types";

// Helper function to convert Firebase user to app user
export const convertFirebaseUser = (firebaseUser: FirebaseUser): User => {
  return {
    id: firebaseUser.uid,
    email: firebaseUser.email || "",
    name:
      firebaseUser.displayName || firebaseUser.email?.split("@")[0] || "User",
    role: firebaseUser.email === "admin@company.com" ? "admin" : "user",
    avatar: firebaseUser.photoURL || undefined,
    emailVerified: firebaseUser.emailVerified,
    creationTime: firebaseUser.metadata.creationTime,
    lastSignInTime: firebaseUser.metadata.lastSignInTime,
  };
};

// Helper function to convert Firebase error codes to user-friendly messages
export const getErrorMessage = (errorCode: string): string => {
  switch (errorCode) {
    case "auth/invalid-credential":
    case "auth/invalid-email":
    case "auth/user-not-found":
    case "auth/wrong-password":
      return "Invalid email or password";
    case "auth/too-many-requests":
      return "Too many failed attempts. Try again later";
    case "auth/popup-closed-by-user":
      return "Sign-in cancelled";
    case "auth/popup-blocked":
      return "Popup blocked. Please allow popups and try again";
    case "auth/network-request-failed":
      return "Network error. Please check your connection";
    case "auth/email-already-in-use":
      return "Email is already registered";
    case "auth/weak-password":
      return "Password should be at least 6 characters";
    case "auth/user-disabled":
      return "This account has been disabled";
    case "auth/operation-not-allowed":
      return "This sign-in method is not enabled";
    case "auth/account-exists-with-different-credential":
      return "Account exists with different sign-in method";
    default:
      return "An error occurred during authentication";
  }
};
